import { _ as _define_property } from "@swc/helpers/_/_define_property";
import React from 'react';
import classnames from 'classnames';
import ScrollableContent from '@wix/da-ds/pkg/ScrollableContent';
export class StreamableList extends React.Component {
    componentDidMount() {
        this.initialFetch();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.streamId !== this.props.streamId) {
            this.initialFetch();
        }
    }
    render() {
        const { id, role, children, className, wrapperClassName, scrolledClassName, bottomedClassName, throttleTimeout = 300, innerRef } = this.props;
        const { isScrolled, isScrolledToBottom } = this.state;
        return /*#__PURE__*/ React.createElement(ScrollableContent, {
            id: id,
            role: role,
            className: className,
            throttleTimeout: throttleTimeout,
            onScrolled: this.onListScroll,
            wrapperClassName: classnames(wrapperClassName, isScrolled && scrolledClassName, isScrolledToBottom && bottomedClassName),
            innerRef: innerRef
        }, children);
    }
    constructor(...args){
        super(...args);
        _define_property(this, "state", {
            isScrolled: false,
            isScrolledToBottom: false
        });
        _define_property(this, "initialFetch", ()=>{
            const { skipInitialFetch, isEmpty, isFetching, hasMore, fetchMore, streamId } = this.props;
            if (!skipInitialFetch && !isFetching && hasMore && isEmpty) {
                fetchMore(streamId);
            }
        });
        _define_property(this, "onListScroll", (scrollTop, distanceToBottom)=>{
            const { isFetching, hasError, hasMore, fetchMore, streamId, onScrolled, loadMoreDistance = 80, // use isEmpty as a 'hasBeenInitialized' and don't try to
            // fetch more (which can happen if the container is small
            // enough to trigger the distance check below)
            isEmpty } = this.props;
            const { isScrolled, isScrolledToBottom } = this.state;
            if (!isEmpty && distanceToBottom < loadMoreDistance && !isFetching && !hasError && hasMore) {
                fetchMore(streamId);
            }
            const isScrolledNew = scrollTop !== 0;
            const isScrolledBottomNew = distanceToBottom < 1;
            if (isScrolled !== isScrolledNew || isScrolledToBottom !== isScrolledBottomNew) {
                // let's only update state when something actually changed because things can get laggy
                this.setState({
                    isScrolled: isScrolledNew,
                    isScrolledToBottom: isScrolledBottomNew
                });
            }
            onScrolled && onScrolled(scrollTop, distanceToBottom);
        });
    }
}
export default StreamableList;

//# sourceMappingURL=StreamedList.js.map